module.exports = __webpack_public_path__ + "img/laptop_robo.68946a9c.svg";